import { DetailBox, DetailBoxColumn } from '@octano/global-ui';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { TranslationsKeys } from '../../../../../../locales/translations';

interface Props {
  studentName: string;
  studentRut: string | null;
  programName: string | null;
}

export default function StudentInfoCard({
  studentName,
  studentRut,
  programName,
}: Props) {
  const { t } = useTranslation(TranslationsKeys.HOMOLOGATION_DETAIL);

  const columns = useMemo<DetailBoxColumn[]>(
    () => [
      {
        title: t('student'),
        body: studentName,
        size: { xs: 12, sm: 3 },
      },
      {
        title: t('rut'),
        body: studentRut || '-',
        size: { xs: 12, sm: 2 },
      },
      {
        title: t('program'),
        body: programName || '-',
        size: { xs: 12, sm: 7 },
      },
    ],
    [t, studentName, studentRut, programName],
  );

  return (
    <div className="d-flex justify-content-end">
      <DetailBox columns={columns} />
    </div>
  );
}
